// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3EOZc","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3utgU"};